/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";
import "whatwg-fetch";
import "bootstrap/js/dist/modal";

var morgan = require("../../site/_data/morgan");

/*------------------------------------*\
    TIMELINE
\*------------------------------------*/
class MapMorgan {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.apiKey = self.elem.getAttribute("data-key");
        self.mapElem = self.elem.querySelector("[data-map]");
        self.locale = self.elem.getAttribute("data-locale");
        self.setMarkers = [];
    }

    /*-------------------------------------------------*\
        Init
    \*-------------------------------------------------*/
    init() {
        let self = this;

        // Load the Google Maps API, passing in our API key
        loadGoogleMapsApi({
            key: self.apiKey,
            language: self.locale == "cym" ? "cy" : "en",
        })
            .then(function (googleMaps) {
                // Call the function that initialises the rendering of the map
                self.googleMaps = googleMaps;

                // Render the map
                self.renderMap();
            })
            .catch(function (error) {
                console.error(error);
            });
    }

    /*-------------------------------------------------*\
        Render map
    \*-------------------------------------------------*/
    renderMap() {
        let self = this;

        // Create the map options
        let mapOptions = {
            zoom: 9,
            minZoom: 8,
            maxZoom: 16,
            center: new self.googleMaps.LatLng(53.614266, -3.531998),
            disableDefaultUI: true,
            zoomControl: true,
            styles: [
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
                },
                {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [{ color: "#ffffff" }, { lightness: 17 }],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        { color: "#ffffff" },
                        { lightness: 29 },
                        { weight: 0.2 },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{ color: "#ffffff" }, { lightness: 18 }],
                },
                {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [{ color: "#ffffff" }, { lightness: 16 }],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{ color: "#dedede" }, { lightness: 21 }],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        { visibility: "on" },
                        { color: "#ffffff" },
                        { lightness: 16 },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        { saturation: 36 },
                        { color: "#333333" },
                        { lightness: 40 },
                    ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [{ color: "#fefefe" }, { lightness: 20 }],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [
                        { color: "#fefefe" },
                        { lightness: 17 },
                        { weight: 1.2 },
                    ],
                },
            ],
        };

        // Create the map
        self.map = new self.googleMaps.Map(self.mapElem, mapOptions);

        // Render overlay
        self.renderOverlay();

        self.renderMarkers();
    }

    /*-------------------------------------------------*\
        Render overlay
    \*-------------------------------------------------*/
    renderOverlay() {
        let self = this;

        // Set overlay bounds
		const overlayBounds = {
			north: 54.10804552225946, // increase = up
			south: 53.60831189326995, // increase = up
			east: -3.203802705436044, // increase = left
			west: -4.438663790093805, // increase = left
		};

		// Create overlay
		const overlay = new google.maps.GroundOverlay(
			"../../assets/images/morgan-map-overlay.png",
			overlayBounds
		);

        // Add overlay to map
        overlay.setMap(self.map);
    }

    /*-------------------------------------------------*\
        Render markers
    \*-------------------------------------------------*/
    renderMarkers() {
        let self = this;

        // Create empty array to store the markers
        let markers = [];

        // Create markers
        morgan.locations.map((marker) => {
            markers.push(marker);
        });

        // Create a new infoWindow
        let infoWindow = new self.googleMaps.InfoWindow();

        // Create the marker icon
        let icon = {
            path: "M40.8,20.4A20.4,20.4,0,0,0,0,20.4C0,31.7,20.4,52.8,20.4,52.8S40.8,31.7,40.8,20.4",
            fillOpacity: 1,
            fillColor: window
                .getComputedStyle(document.documentElement)
                .getPropertyValue("--primary"),
            strokeColor: "#ffffff",
            strokeWeight: 1,
            scale: 1,
            labelOrigin: new google.maps.Point(20, 22),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 53),
        };

        // Create the bounds object, which will be configured later based on the marker locations
        let bounds = new self.googleMaps.LatLngBounds();

        // Loop through the markers
        for (let i = 0; i < markers.length; i++) {
            // Get the marker data
            let markerData = markers[i];

            // Create a new LatLng object to use for the marker position
            let latLng = new self.googleMaps.LatLng(
                markerData.lat,
                markerData.lng
            );
            let label = String(i + 1);

            // Create the marker object
            let marker = new self.googleMaps.Marker({
                position: latLng,
                map: self.map,
                icon: icon,
                label: {
                    color: "#fff",
                    fontSize: "18px",
                    fontWeight: "600",
                    text: label,
                },
            });

            // Add this marker to the self.setMarkers global array
            self.setMarkers.push(marker);

            // Handle marker clicks
            self.googleMaps.event.addListener(marker, "click", function (e) {
				// Build the content for the infoWindow
				let infoWindowContent = `
                    <div class="map__info-window">
                        <h2 class="map__info-window-heading">${
							markerData.title
						}</h2>
                        <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#modal-existing-${
							i + 1
						}">Show existing</button>
                        <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#modal-proposed-${
							i + 1
						}">Show proposed</button>
                    </div>
                `;

				// Add the content to the infoWindow
				infoWindow.setContent(infoWindowContent);
				infoWindow.open(self.map, marker);
			});
        }
    }
}

export default MapMorgan;
